import { Divider, ListItemIcon, ListItemText, MenuItem, MenuList, Popover } from '@mui/material';
import './header.css'
import { useState } from 'react';
import LogoutIcon from '@mui/icons-material/Logout';
import LockResetIcon from '@mui/icons-material/LockReset';
import { deleteToken } from '../../utils/util';

const TITLES = {
  "": "Dashboard",
  "home": "Dashboard",
  "dashboard": "Dashboard",
  "mock-test": "Mock Tests",
  "create-mocktest": "Create Mocktest",
  "question-library": "Question Library",
  "membership": "Membership",
  "manage-plans": "Manage Plans",
  "broadcast": "Broadcast",
  "audit-log": "Audit Log",
  "error-log": "Error Log",
  "reset-password": "Reset Password",
  "email-scheduler": "Email Scheduler",
}

const Header = ({ title }) => {
  const pageTitle = TITLES[title] !== undefined
    ? TITLES[title]
    : title.replaceAll('-', ' ').replace(/(^\w{1})|(\s+\w{1})/g, l => l.toUpperCase())

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const id = open ? 'account-popover' : undefined;
  const goToReset = () => { document.location.href = '/reset-password' }
  const logout = () => { deleteToken(); document.location.href = "/login" }

  return (
    <header style={{ height: 64, flex: 'none', display: 'flex', alignItems: 'center', padding: '0 28px', borderBottom: '2px solid var(--color-divider)', background: 'var(--color-bg)' }}>
      <div style={{ flex: 1 }}>
        <div style={{ fontSize: 10, letterSpacing: '.12em', textTransform: 'uppercase', color: 'var(--color-neutral-500)' }}>TYK Admin</div>
        <div style={{ fontFamily: 'var(--font-heading)', fontWeight: 800, fontSize: 21, lineHeight: 1, letterSpacing: '-0.01em' }}>{pageTitle}</div>
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, height: 36, padding: '0 10px', background: 'var(--color-surface)', border: '1px solid var(--color-divider)', minWidth: 220, color: 'var(--color-neutral-500)' }}>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.3-4.3"/></svg>
          <span style={{ fontSize: 13 }}>Search…</span>
        </div>
        <button className="btn btn-icon btn-secondary" aria-label="Notifications">
          <svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M10.268 21a2 2 0 0 0 3.464 0"/><path d="M3.262 15.326A1 1 0 0 0 4 17h16a1 1 0 0 0 .74-1.673C19.41 13.956 18 12.499 18 8A6 6 0 0 0 6 8c0 4.499-1.411 5.956-2.738 7.326"/></svg>
        </button>
        <div
          onClick={(e) => setAnchorEl(e.currentTarget)}
          aria-describedby={id}
          style={{ display: 'flex', alignItems: 'center', gap: 9, paddingLeft: 12, borderLeft: '2px solid var(--color-divider)', cursor: 'pointer' }}
        >
          <div style={{ width: 34, height: 34, background: 'var(--color-accent)', color: 'var(--color-bg)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'var(--font-heading)', fontWeight: 800, fontSize: 13 }}>RA</div>
          <div style={{ lineHeight: 1.2 }}>
            <div style={{ fontSize: 13, fontWeight: 600 }}>R. Admin</div>
            <div style={{ fontSize: 11 }} className="text-muted">Super Admin</div>
          </div>
        </div>
      </div>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <MenuList>
          <MenuItem onClick={goToReset}>
            <ListItemIcon><LockResetIcon fontSize="small" /></ListItemIcon>
            <ListItemText>Reset Password</ListItemText>
          </MenuItem>
          <Divider />
          <MenuItem onClick={logout}>
            <ListItemIcon><LogoutIcon fontSize="small" /></ListItemIcon>
            <ListItemText>Logout</ListItemText>
          </MenuItem>
        </MenuList>
      </Popover>
    </header>
  )
}
export default Header
